const enrolments = {
	title: "Enrolments",
	title_org: "Companies",
	title_companies: "Companies",
	new_enrolment: "New Enrolment",
	edit_enrolment: "Edit Enrolment: {name}",
	view_enrolment: "View Enrolment: {name}",
	create_enrolment_org: "Create Organisation",
	view_enrolment_org: "View Organisation: {name}",
	edit_enrolment_org: "Company. {name}",
	list_title: "List of Enrolments",
	list_title_org: "List of Enrolled Organisations",
	list_subtitle: "Manage Enrolment",
	list_subtitle_org: "Manage Enrolled Organisations",
	create_title: "Create New Enrolment",
	update_title: "Update Enrolment",
	details_title: "Enrolment Details",
	address_title: "Address Details",
	id: "ID",
	visiting_address: "Visiting Address",
	invoice_address: "Invoice Address",
	participants: "Participants",
	course: "Course",
	name: "Name",
	number: "Number",
	p_first_name: "First Name",
	p_last_name: "Last Name",
	p_email: "Email",
	p_mobile: "Mobile",
	p_date_of_birth: "Date of Birth",
	p_address_street: "Street",
	p_address_city: "City",
	p_address_state: "State",
	p_address_zip: "Zip",
	p_address_country: "Country",
	p_image: "Image",
	p_company: "Company",
	invoice_email: "Invoice Email",
	enrolled: "Enrolled",
	dept_chief: "Department chief",
	o_vat: "VAT",
	o_name: "Company",
	o_reference: "Reference/PO",
	o_requestor: "Requestor",
	o_first_name: "Requestor First Name",
	o_last_name: "Requestor Last Name",
	o_email: "Requestor Email",
	o_date_of_birth: "Date of Birth",
	o_address_street: "Street",
	o_address_city: "City",
	o_address_state: "State",
	o_address_zip: "Zip",
	o_address_country: "Country",
	employeed_from: "Employeed From",
	comment: "Notes",
	internal_notes: "Internal Notes",
	no_of_participants: "Number of Participants",
	verify_title: "List of Matching Participants",
	add_to_participant: "Add to Paricipant",
	add_to_participant_success: "Successfully added to participant",
	add_to_participant_error: "Failed to add as participant",
	already_enrolled: "This participant/enrolment is already enrolled in this course.",
	convert_to_participant_message: "Are you sure you want to convert this enrolment as participant?",
	force_accept: "Accept enrolment as new student ",
	merge_title: "Merge Companies",
	merge_sub: "Choose which company data will be merged to",
	merge_confirm: "Companies and all their data will be merged into one. This action is not reversible! Would you like to proceed?",
	no_company_selected: "Select a company",
	merge_success: "Companies successfully merged",
	merge_failed: "Failed to merge companies",
	merge: "Merge",
	search: "Search",
	enrol: "Enroll",
	image_participant: "Use participant image",
	image_enrolment: "Use enrolment image",
	status: "Status",
	single_enrolment_successful: "Selected student successfully enrolled.",
	single_enrolment_failed: "Failed to enrol selected students.",
	multi_enrolment_successful: "Selected students successfully enrolled.",
	multi_enrolment_successful_with_skip: "Selected students successfully enrolled. Some users have already been enrolled and will be skipped.",
	multi_enrolment_failed: "Failed to enrol selected students.",
	vat_invalid: "Company {name} with this VAT is already registered.",
	select_course_title: "Select Course",
	merge_th_field: "Field",
	merge_th_enrolment: "Enrolment",
	merge_th_participant: "Participant",
	merge_th_result: "Result",
	active_enrolments_cannot_delete: "There is an active enrolment(s). Cannot delete company.",
	original_course: "Original Course",
	select_enrolment_type: "Select enrolment type",
	payment_method: "Payment method",
	mapped_to: "Automatically mapped to student with ID:",
	departments: "Departments",
	department: "Department",
	new_department: "New Department",
	edit_department: "Edit Department",
	employee_user_access: "Would you like to give access for {first_name} {last_name} to {company_name}?",
	employee_user_remove: "Would you like to remove access for {first_name} {last_name} to {company_name}?",
	enrolment_edit: "Edit enrollment",
	enrolment_updated: "Enrollment updated",
	multiple_companies: "Multiple companies",
	create_attendee_enrolment: "Create enrolment",
	edit_attendee_enrolment: "Edit enrolment",
	select_department: "Select department",
	company_admin: "Company admin",
};
export default enrolments;